import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import URL from '../../Environment';
import Maxdownload from './maxdownload';
import IMGPATHS from '../../ImgPaths';

const Downloadform = () => {
    const [DFData, setDFData] = useState([]);
    const [loadingDF, setDFLoading] = useState(true);
    const [errorDF, setDFError] = useState(null);
    const [xsrfToken, setXsrfToken] = useState(null);
    const [tokenError, setTokenError] = useState(null);

    // useEffect(() => {
    //     const fetchToken = async () => {
    //         if (xsrfToken) {
    //             console.log('Token already exists, skipping fetch.');
    //             return;
    //         }

    //         try {
    //             const tokenResponse = await Axios.get(`${URL}api/Antiforgery/GetAntiforgeryToken`, {
    //                 withCredentials: true,
    //             });
    //             const token = tokenResponse.data.token;
    //             if (!token) {
    //                 console.error('Failed to retrieve Anti-Forgery Token');
    //                 setTokenError('No token received');
    //                 return;
    //             }
    //             setXsrfToken(token);
    //             console.log('Request Token:', token);

    //             const getCookie = (name) => {
    //                 const value = `; ${document.cookie}`;
    //                 const parts = value.split(`; ${name}=`);
    //                 if (parts.length === 2) return parts.pop().split(';').shift();
    //             };
    //             const cookieToken = getCookie('.AspNetCore.Antiforgery');
    //             console.log('Cookie Token:', cookieToken);
    //             if (token === cookieToken) {
    //                 console.warn('Request token and cookie token are identical!');
    //             } else if (cookieToken) {
    //                 console.log('Request token and cookie token are different, which is correct.');
    //             } else {
    //                 console.warn('No cookie token found!');
    //             }
    //         } catch (err) {
    //             console.error('Error fetching token:', err.response ? err.response.data : err.message);
    //             setTokenError(err.response ? err.response.data.message : err.message);
    //         }
    //     };

    //     fetchToken();
    // }, []);

    useEffect(() => {
        const fetchDFData = async () => {
            try {
                const response = await Axios.get(`${URL}api/DownloadForm/GetDownloadForm`, {
                    withCredentials: true,
                });
                setDFData(response.data);
                setDFLoading(false);
            } catch (error) {
                setDFError(error.message);
                setDFLoading(false);
            }
        };

        fetchDFData();
    }, []);

    // const countDownloadForm = async (fileid) => {
    //     if (!xsrfToken) {
    //         console.error('No Anti-Forgery Token available');
    //         setTokenError('No Anti-Forgery Token available');
    //         return;
    //     }

    //     console.log('AAAAA:', process.env.REACT_APP_API_KEY);
    //     console.log('DDDDD:', process.env.PUBLIC_URL);

    //     try {
    //         const response = await Axios.post(
    //             `${URL}api/DownloadForm/CountDownloadForm`,
    //             { id: fileid },
    //             {
    //                 headers: {
    //                     'X-XSRF-TOKEN': xsrfToken,
    //                     'X-API-Key': process.env.REACT_APP_API_KEY,
    //                     'Content-Type': 'application/json',
    //                 },
    //                 withCredentials: true,
    //             }
    //         );
    //         console.log('Response:', response.data);
    //     } catch (err) {
    //         console.error('Error:', err.response ? err.response.data : err.message);
    //     }
    // };

    const countDownloadForm = async (fileid) => {
        if (!Number.isInteger(fileid) || fileid <= 0) {
            console.log('Invalid file ID');
            return;
        }

        try {
            const response = await Axios.post(
                `${URL}api/Proxy/CountDownloadForm`,
                { id: fileid },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            console.log('Response:', response.data);
        } catch (err) {
            console.log('Error:', err.response ? err.response.data : err.message);
        }
    };

    if (loadingDF) {
        return <div>Loading...</div>;
    }

    if (errorDF) {
        return <div>Error: {errorDF}</div>;
    }

    return (
        <div>
            {tokenError && <div style={{ color: 'red' }}>Token Error: {tokenError}</div>}
            <section className="breadcrumbs">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 a-breadcrumbs" style={{ color: '#ffffff' }}>
                            <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link> 
                            <i className="fa fa-angle-right" /> <a href="downloadform" className="a-breadcrumbs">ดาวน์โหลดแบบฟอร์ม</a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="page-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-9 col-sm-9 mb-sm-50" style={{ fontFamily: 'Cordia New' }}>
                            <h2 className="title-section mt-0 mb-0">
                                <span>ดาวน์โหลดแบบฟอร์ม</span>
                            </h2>
                            <br />
                            <div className="divider gray left mt-20 mb-25"></div>
                            <table className="table table-model-2 table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>แบบฟอร์ม</th>
                                        <th style={{ textAlign: 'right' }}>วันที่ประกาศ</th>
                                        <th style={{ textAlign: 'center' }}>ประกาศโดย</th>
                                        <th style={{ textAlign: 'right' }}>ดาวน์โหลด(ครั้ง)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {DFData.map((form, index) => (
                                        <tr key={index}>
                                            <td></td>
                                            <td>
                                                <a
                                                    href={`${IMGPATHS}` + `Form/DownloadForm/${form.link}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#0094ff' }}
                                                    onClick={() => countDownloadForm(form.id)}
                                                >
                                                    {form.topicform}
                                                </a>
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {format(new Date(form.dateform), 'd MMMM, yyyy HH:mm')}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{form.uploadby}</td>
                                            <td style={{ textAlign: 'center', color: '#0094ff' }}>
                                                <i className="fa fa-cloud-download"></i>    
                                                <b>{form.downloadtime}</b>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-3 sidebar">
                            <Maxdownload />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Downloadform;